export var getSignInURL = function(redirectURL) {
    var returnTo = redirectURL ? "?redirect_uri=".concat(redirectURL) : "";
    return "".concat(process.env.NEXT_PUBLIC_URL_IDENTITY, "/login/").concat(returnTo);
};
